/**
 * Centralized registry of all application permissions.
 * This ensures type safety and prevents typo-related security issues.
 */
export const PERMISSIONS = {
  USER: {
    VIEW: 'user:view',
    MANAGE: 'user:manage',
  },
  ROLE: {
    MANAGE: 'role:manage',
  },
  SCHOLARSHIP: {
    MANAGE: 'scholarship:manage',
    APPROVE: 'scholarship:approve',
  },
  FEEDBACK: {
    MANAGE: 'feedback:manage',
  },
  SYSTEM: {
    CONFIG: 'system:config',
    DLQ_MANAGE: 'dlq:manage',
  },
  REPORTS: {
    GENERATE: 'reports:generate',
  },
  OBSERVABILITY: {
    VIEW: 'observability:view',
  },
  WORKFLOW: {
    VIEW: 'workflow:view',
    FORENSIC: 'workflow:forensic',
    OBSERVABILITY: 'workflow:observability',
  },
  AUDIT: {
    VIEW: 'audit:view',
  },
  JIT: {
    MANAGE: 'jit:manage',
  },
  COMMUNICATION: {
    MANAGE: 'communication:manage',
  },
  SECURITY: {
    VIEW: 'security:view',
  },
  FINANCIAL: {
    VIEW: 'financial:view',
  },
  GOVERNANCE: {
    VIEW: 'governance:view',
    MANAGE: 'governance:manage',
  },
  AUTHENTICATED: {
    ACCESS: 'authenticated:access',
  },
  PAYMENT_OPTIONS: {
    MANAGE: 'payment-options:manage',
  },
  FEE: {
    READ: 'fee:read',
    CREATE: 'fee:create',
    UPDATE: 'fee:update',
    DELETE: 'fee:delete',
  },
  FEE_STRUCTURE: {
    READ: 'fee-structure:read',
    CREATE: 'fee-structure:create',
    UPDATE: 'fee-structure:update',
    DELETE: 'fee-structure:delete',
    MANAGE: 'fee-structure:manage',
    IMPACT: 'fee-structure:impact',
    APPLY_ALL: 'fee-structure:apply-all',
  },
  INSTALLMENT_PLAN: {
    READ: 'installment-plan:read',
    CREATE: 'installment-plan:create',
    UPDATE: 'installment-plan:update',
    DELETE: 'installment-plan:delete',
    MANAGE: 'installment-plan:manage',
  },
  STUDENT: {
    ACCESS: 'student:access',
  },
  SEARCH: {
    GLOBAL: 'search:global',
  },
  STAFF: {
    ACCESS: 'staff:access',
    VIEW_PAYMENT_TRENDS: 'staff:view-payment-trends',
    VIEW_STATISTICS: 'staff:view-statistics',
  },
  PAYMENT: {
    VERIFY: 'payment:verify',
  },
  STUDENT_FINANCIALS: {
    ACCESS: 'student-financials:access',
  },
  ANNOUNCEMENT: {
    MANAGE: 'announcement:manage',
  },
  NOTIFICATIONS: {
    MANAGE: 'notifications:manage',
  },
  PRIVACY: {
    EXPORT: 'user:privacy-export',
    DELETE_ACCOUNT: 'user:privacy-delete-account',
  },
  ACADEMIC: {
    SESSION_READ: 'academic:session:read',
    SESSION_CREATE: 'academic:session:create',
    SESSION_OPEN: 'academic:session:open',
    SESSION_CLOSE: 'academic:session:close',
    SESSION_RETRY: 'academic:session:retry',
    SESSION_OVERRIDE: 'academic:session:override',
    SESSION_DELETE: 'academic:session:delete',
    SESSION_RESTORE: 'academic:session:restore',
    SESSION_RECONCILE: 'academic:session:reconcile',
    RECORD_IMPORT: 'academic:record:import',
    RECORD_WRITE: 'academic:record:write',
    POLICY_MANAGE: 'promotion:policy:manage',
  },
} as const;

